import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
// import MaterialTable from "@material-table/core";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import { getData, postFile, putData, deleteData, getFile } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import AlertMessages from "../Mains/Alerts";

const ProQuestions = () => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [questionList, setQuestionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [questionCount, setQuestionCount] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState({});
  const [draggingItem, setDraggingItem] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [isProgressBarOpen, setIsProgressBarOpen] = useState(false);
  const [csv, setCsv] = useState(null);
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;
  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;
  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };
  const handleToggles = () => {

    setIsProgressBarOpen(!isProgressBarOpen);
  };
  const handleDeleteQuestion = async (questionId) => {
    // if (customer.userRole === "S" ) {
    //   let result = await deleteData(`users/question/ ${questionId}`);
    //   fetchQuestions();
    //   if (result) {
    //     // console.log("Question Deleted");
    //     setAlerts([{ variant: "warning", heading: "Question Deleted" }]);
    //   } else {
    //     // console.log("error in deletion of question");
    //     setAlerts([{ variant: "danger", heading: "error in deletion of question" }]);
    //   }
    if (userRole === "S") {
      let result = await deleteData(`users/question/ ${questionId}`);
      fetchQuestions();
      if (result) {
        // console.log("Question Deleted");
        setAlerts([{ variant: "warning", heading: "Question Deleted" }]);
      } else {
        setAlerts([{ varient: "danger", heading: "Only Super Admins can delete questions" }]);
      }
    }
  };

  const handleDragStart = (e, item) => {
    setDraggingItem(item);
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetItem) => {
    if (!draggingItem || draggingItem === targetItem) return;

    const updatedList = [...questionList];
    const draggingIndex = updatedList.indexOf(draggingItem);
    const targetIndex = updatedList.indexOf(targetItem);

    const draggingQuestionId = draggingItem.questionId;
    const targetQueOrder = targetIndex + 1;

    updatedList.splice(draggingIndex, 1);
    updatedList.splice(targetIndex, 0, draggingItem);

    setQuestionList(updatedList);
    updateSequence(draggingQuestionId, targetQueOrder);
    console.log("test", draggingQuestionId, targetQueOrder);
  };

  const updateSequence = async (questionId, queOrder) => {
    try {
      await putData(`/users/drag-drop-question-list/${questionId}/${queOrder}/?userId=${user}`);
      console.log(`Question ${questionId} sequence updated to ${queOrder}`);
      fetchQuestions();
    } catch (error) {
      console.error(`Failed to update sequence for question ${questionId}:`, error);
    }
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0 && acceptedFiles[0].type === "text/csv") {
      const file = acceptedFiles[0];
      validateCSV(file)
        .then(() => {
          setCsv(file);
        })
        .catch((error) => {
          setAlerts([{ variant: "danger", heading: error }]);
        });
    } else {
      setAlerts([{ variant: "danger", heading: "Please select a valid CSV file." }]);
    }
  };

  const validateCSV = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file provided");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const rows = reader.result.split(/\r?\n/);
        if (rows.length === 0) {
          reject("CSV file is empty");
          return;
        }

        const headers = rows[0].split(",").map((header) => header.trim().toLowerCase());

        const requiredHeaders = [
          "QuestionTypeID",
          "QuestionTitle",
          "Question",
          "AnswerCode",
          "Answer",
        ].map((header) => header.toLowerCase());

        const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

        if (missingHeaders.length > 0) {
          const errorMessage = `Missing required headers: ${missingHeaders.join(", ")}`;
          reject(errorMessage);
          setAlerts([{ variant: "danger", heading: errorMessage }]);
        } else {
          resolve();
          console.log("CSV validation successful");
        }
      };
      reader.onerror = () => {
        reject("Error reading CSV file");
      };
      reader.readAsText(file);
    });
  };

  const handleCsvUpload = async () => {
    if (!csv) {
      console.log("No CSV file selected");
      return;
    }
    const formData = new FormData();
    formData.append("file", csv);
    let result = await postFile(`users/add-question-csv?userId=${user}`, formData);
    if (result) {
      // console.log("question added from csv");
      setAlerts([{ variant: "success", heading: "Adding Questions from CSV." }]);
      setCsv(null);
      fetchQuestions();
    } else {
      // console.log("Failed to add Question");
      setAlerts([
        {
          variant: "danger",
          heading: "Error adding question. Please try again later.",
        },
      ]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "text/csv",
  });

  const handleCsvChange = () => {
    setCsv(null);
  };

  const fetchQuestionCount = async () => {
    let result = await getData("users/get-question-count?userId=" + user);
    setQuestionCount(result || []);
  };

  const handleExportCsv = async () => {
    try {
      const response = await getFile(`users/export-question-answer-sample-excel`);
      console.log(response);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Profiling_question_template.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      setAlerts([{ variant: "danger", heading: "Error exporting CSV." }]);
    }
  };

  const fetchQuestions = async () => {
    setIsLoading(true);
    let result = await getData(`users/question-list?userId=${user}`);
    setQuestionList(result || []);
    setIsLoading(false);
  };
  useEffect(
    function () {
      fetchQuestionCount();
      if (searchTerm.trim() === "") {
        fetchQuestions();
      }
    },
    [searchTerm]
  );

  const handleSearch = async () => {
    let result = await getData(`users/question-list?search=${searchTerm}&userId=${user}`);
    setQuestionList(result);
    setIsLoading(false);
  };

  const handleStatusChange = async (questionId, newStatus) => {
    // setIsLoading(true);
    try {
      setQuestionList(questionList.map((item) => (item.questionId === questionId ? { ...item, questionStatus: newStatus } : item)));
      await putData(`users/update-question-status/${questionId}/${newStatus}`);
      // fetchQuestions();
      // setIsLoading(false);
      console.log(newStatus);
    } catch (error) {
      console.error(`Failed to update status for question ${questionId}:`, error);
      setAlerts([{ variant: "danger", heading: "Failed to update question status" }]);
    }
  };

  const fillQuestions = () => {
    const sortedQuestions = questionList.sort((a, b) => a.questionSequence - b.questionSequence);

    return sortedQuestions.map((item) => {
      return (
        <tr
          key={item.questionId}
          draggable
          onDragStart={(e) => handleDragStart(e, item)}
          onDragEnd={handleDragEnd}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, item)}
        >
          <td>{item.questionSequence}</td>
          <td>{item.questionCode}</td>
          <td>
            <abbr title={item.question}>{item.questionTitle}</abbr>
          </td>
          <td>{item.queType}</td>
          <td className="d-flex justify-content-center">
            <div className="col-lg-4 form-check  form-switch p-0">
              <input
                className="form-check-input ms-2"
                type="checkbox"
                role="switch"
                id={`statusSwitch-${item.questionId}`}
                checked={item.questionStatus === 1}
                onChange={(e) => handleStatusChange(item.questionId, e.target.checked ? 1 : 0)}
              />
            </div>
          </td>
          <td>
            <Link to={`/edit-questions?questionId=${item.questionId}`}>
              <i className="bi bi-eye mx-1 fs-20"></i>
            </Link>
            {userRole === "S" && <i className="bi bi-trash fs-20" onClick={() => handleDeleteQuestion(item.questionId)}></i>}
          </td>
        </tr>
      );
    });
  };

  // console.log(searchTerm);
  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggles} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Add questions
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="column p-3">
            <div className="row">
              <div className="col-lg-4">
                <div className="card p-2 border-light-subtle">
                  <div className="common_form p-2">
                    <label className="fw-bolder" htmlFor="">
                      Upload CSV
                      <br />
                      <span className="text-grey fs-13">{questionCount.UploadCSV} answers added</span>
                    </label>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#questioncsvupload" className="form-control btn btn-success">
                      <label for="">
                        Add <i className="bi bi-chevron-right  fs-12"></i>
                      </label>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="card p-2 border-light-subtle">
                  <div className="common_form p-2">
                    <label className="fw-bolder" for="">
                      Add question via form
                      <br />
                      <span className="text-grey fs-13">{questionCount.UploadForm} answers added</span>
                    </label>

                    <Link to="/addquestions">
                      <button type="button" className="form-control btn btn-success">
                        <label for="">
                          Add <i className="bi bi-chevron-right  fs-12"></i>
                        </label>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade "
            id="questioncsvupload"
            tabindex="-1"
            role="dialog"
            aria-labelledby="questioncsvupload"
            aria-hidden="true"
            onBlur={() => handleCsvUpload()}
          >
            <div className="modal-dialog  modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="column">
                  <div className="col-lg-12">
                    <div className="card px-3 border-light-subtle">
                      <div className="common_form p-2 text-center">
                        <label for="">Import CSV</label>
                        <div className="d-grid gap-2 d-md-block d-md-flex justify-content-md-center mb-3">
                          <button className="btn csv-btn fw-bolder col-12 text-success" type="button">
                            <a onClick={() => handleExportCsv()} target="_blank" rel="noreferrer">
                              Download template
                            </a>
                          </button>
                        </div>
                        <div className="drop-zone ">
                          {csv ? (
                            <div className="image-preview-container">
                              <img src={process.env.PUBLIC_URL + "/Images/csv.png"} alt="Uploaded" className="image-preview" />
                              <div onClick={handleCsvChange} className="text-overlay bg-transparent">
                                <i className="bi bi-x fs-42 position-absolute top-0 end-0"></i>
                              </div>
                            </div>
                          ) : (
                            <div className="dropzone">
                              <input {...getInputProps()} />
                              <div {...getRootProps()} className="drop-zone__prompt fs-16 fw-500 text-dark">
                                <div className="text-center mb-3">
                                  <i className="bi bi-images fs-50 text-green"></i>
                                </div>
                                Drop your files here or <span className="text-green">browse</span>
                                <br />
                                <span className="text-grey fs-13">Maximum size: 50MB</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="column p-3">
            <div className="col-lg-12">
              <div className="card px-3 border-light-subtle">
                <MaterialTable
                  title=""
                  style={{ padding: 12, paddingBottom: 0, boxShadow: "none", fontWeight: "bold", fontSize: "12px" }}
                  columns={[
                    { title: "S.No", field: "sno", width: "10%" },

                    { title: "Type", field: "type" },
                    { title: "Question statement", field: "ques", width: "50%" },
                    { title: "Question code", field: "qcode" },
                  ]}
                  data={[
                    { sno: "1", type: "Multi-select", ques: "What's your favorite childhood memory?", qcode: 12422432 },
                    { sno: "2", type: "One-line text", ques: "What's your favorite movie and why?", qcode: 12422432 },
                    { sno: "3", type: "Dropdown", ques: "What was your favorite subject in school?", qcode: 12422432 },
                    { sno: "4", type: "Single-select", ques: "What's your favorite family holiday tradition?", qcode: 12422432 },
                  ]}
                  options={{
                    headerStyle: {
                      backgroundColor: "rgb(240,240,240)",
                      padding: "8px 16px",
                      color: "#6B7280",
                      fontSize: "12px",
                    },
                    actionsColumnIndex: -1,
                    searchFieldAlignment: "left",
                    paginationAlignment: "left",
                    sorting: true,
                    searchFieldStyle: {
                      border: "0.5px solid #6EE7B7",
                      borderRadius: "4px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      color: "#333",
                      backgroundColor: "#fff",
                      boxSizing: "border-box",
                      width: "25vw",
                      marginLeft: "-2.9vw",
                    },
                  }}
                  localization={{
                    header: {
                      actions: "Delete",
                    },
                  }}
                  actions={[
                    {
                      icon: () => (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                        </svg>
                      ),
                      tooltip: "delete",
                      onClick: (event, rowData) => alert("You deleted " + rowData.type),
                    },
                  ]}
                />
              </div>
            </div>
          </div> */}

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1 ">
                    <div className="search_box">
                      <input type="text" value={searchTerm} className="w-100 form-control" onChange={(event) => setSearchTerm(event.target.value)} />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={() => handleSearch()}>
                        <i className="bi bi-search me-1"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-3 d-flex align-items-center">
                  <div className="mt-4 mt-lg-0">
                    <label htmlFor="" className=" fs-15">
                      Advance Search
                    </label>
                  </div>
                </div> */}
                {/* <div className="col-lg-6 d-flex justify-content-end">
                  <div className="mt-3 mt-lg-0">
                    <Link to="/profiling-questions">
                      <button className="btn btn-success   py-0 fs-12 fw-600">
                        <i className="bi bi-plus fs-15"></i> Add a question
                      </button>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20 text-center">
                <thead className="table-light  fs-12 lh-16  border-top">
                  <tr>
                    {/* <th>Question Title</th>
                    <th>Question text</th>
                    <th>Question Category</th>
                    <th>Geo</th>
                    <th>Languages</th>
                    <th>Question type</th>
                    <th>Answer type</th>
                    <th>Question Visibility</th>
                    <th>Status</th> */}

                    <th>Order No.</th>
                    <th>Question Code</th>
                    <th>Question Title</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  ) : (
                    fillQuestions()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProQuestions;
